jQuery(document).ready(function ($) {

    var notificationHeight = $('.c-notification').outerHeight();

    $('.hasNotification').css('margin-bottom', notificationHeight);

    $('.c-modal__close ').click(function () {
        $(this).parents('.c-modal').remove();
    });

    $('.js-filterToggle').click(function () {
        $('.s-store-locator__aside').toggleClass('js-filterActive');
        $('.filter-background').toggleClass('js-filterActive');
    });

    $('.js-menuToggle').click(function () {
        $('body').toggleClass('js-menuActive');
    })

    $('.js-productFilterToggle').click(function () {
        $('.s-product-overview__aside').toggleClass('js-filterActive');
        $('.filter-background').toggleClass('js-filterActive');
    })

    $('.js-modalTrigger').click(function () {
        $('.c-modal').addClass('js-modalActive');
    });

    $(function () {
        $('.c-article-blocks__single.lslide').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });
    });


    var articleSlider = $('#articleSlider').lightSlider({
        item: 3,
        controls: false,
        slideMargin: 20,
        pager: true,
        slideMove: 3,
        speed: 500,
        responsive: [
            {
                breakpoint: 950,
                settings: {
                    item: 2,
                    slideMove: 2,
                }
            },
            {
                breakpoint: 680,
                settings: {
                    item: 1,
                    speed: 1000,
                    slideMove: 1,
                }
            }
        ],
        onSliderLoad: function (el) {
            var maxHeight = 0,
                container = $(el),
                children = container.children();
            children.each(function () {
                var childHeight = $(this).height();
                if (childHeight > maxHeight) {
                    maxHeight = childHeight;
                }
            });
            container.height(maxHeight);

            displayArticleSliderNavigation();
        },

        onAfterSlide: function (el) {
            displayArticleSliderNavigation();
        }
    });

    $('.prevArticles').click(function () {
        articleSlider.goToPrevSlide();
    });
    $('.nextArticles').click(function () {
        articleSlider.goToNextSlide();
    });

    function displayArticleSliderNavigation() {

        var currentItem = $('#articleSlider .lslide.active').index()
        var previousButton = $('.c-articles-slider__controls .prevArticles')
        var nextButton = $('.c-articles-slider__controls .nextArticles')
        var itemLength = $('.c-article-blocks__single').length


        if (currentItem === 0) {
            previousButton.css({'opacity': 0, 'pointer-events': 'none'})
        } else {
            previousButton.css({'opacity': 1, 'pointer-events': 'all'})
        }

        if ($(window).width() < 680) {
            if ((currentItem + 1) >= itemLength) {
                nextButton.css({'opacity': 0, 'pointer-events': 'none'})
            } else {
                nextButton.css({'opacity': 1, 'pointer-events': 'all'})
            }
        } else if ($(window).width() < 950) {
            if ((currentItem + 2) >= itemLength) {
                nextButton.css({'opacity': 0, 'pointer-events': 'none'})
            } else {
                nextButton.css({'opacity': 1, 'pointer-events': 'all'})
            }
        } else {
            if ((currentItem + 3) >= itemLength) {
                nextButton.css({'opacity': 0, 'pointer-events': 'none'})
            } else {
                nextButton.css({'opacity': 1, 'pointer-events': 'all'})
            }
        }
    }

    $('body').on('click', '.s-product__information__subject button', function () {

        $('.s-product__information__subject button').removeClass('isActive')
        $(this).addClass('isActive')
        var value = $(this).data('value')
        $("#pa_maten").val(value).trigger('change')
    })

    if ($('#pa_maten').length) {
        var value = $('#pa_maten').val()

        $('.s-product__information__subject button[data-value="' + value + '"]').addClass('isActive')
    }

    $('.coupon.mobile .top').click(function () {
        $(this).closest('.coupon').toggleClass('is-active');
    })

    $('.s-product-overview__aside, .s-store-locator__aside, .js-productFilterToggle, .js-filterToggle').on('click', function (e) {
        e.stopPropagation();
    });

    $(document).on('click', function (e) {

        $('.s-product-overview__aside, .s-store-locator__aside, .filter-background').removeClass('js-filterActive')

    });
});
